import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import energoLogo from "../assets/media/ImageAnekant/EI.png";

function Nav() {
  const [shrink, setShrink] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  /* ===== SHRINK ON SCROLL ===== */
  useEffect(() => {
    const onScroll = () => setShrink(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* ===== CLOSE MENU AFTER NAV CLICK (MOBILE) ===== */
  const handleNavClick = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <nav className={`navbar navbar-expand-lg sticky-top energo-navbar ${shrink ? "shrink" : ""}`}>
      <div className="container-fluid px-lg-5 px-3">

        {/* LOGO */}
        <Link className="navbar-brand" to="/" onClick={handleNavClick}>
          <img src={energoLogo} alt="Energo India" className="navbar-logo" />
        </Link>

        {/* TOGGLER */}
        <button
          className="navbar-toggler"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className="fa fa-bars"></i>
        </button>

        {/* NAV */}
        <div className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}>
          <ul className="navbar-nav mx-auto gap-lg-4">

            <li className="nav-item">
              <NavLink className="nav-link" to="/" onClick={handleNavClick}>
                HOME
              </NavLink>
            </li>

            {/* ACCESSIBLE DROPDOWN */}
            <li
              className={`nav-item dropdown ${dropdownOpen ? "show" : ""}`}
              onMouseEnter={() => window.innerWidth >= 992 && setDropdownOpen(true)}
              onMouseLeave={() => window.innerWidth >= 992 && setDropdownOpen(false)}
            >
              <button
                className="nav-link dropdown-toggle"
                aria-haspopup="true"
                aria-expanded={dropdownOpen}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                onKeyDown={(e) => {
                  if (e.key === "Escape") setDropdownOpen(false);
                }}
              >
                POWER PLANTS
              </button>

              <div className={`dropdown-menu mega-menu ${dropdownOpen ? "show" : ""}`}>
                <div className="mega-grid">
                  <Link className="dropdown-item" to="/cogeneration" onClick={handleNavClick}>
                    Cogeneration
                  </Link>
                  <Link className="dropdown-item" to="/powergenerationplants" onClick={handleNavClick}>
                    Power Generation
                  </Link>
                  <Link className="dropdown-item" to="/renewableenergyindia" onClick={handleNavClick}>
                    Renewable Energy
                  </Link>
                  <Link className="dropdown-item" to="/renewableagenciesindia" onClick={handleNavClick}>
                    Renewable Agencies
                  </Link>
                </div>
              </div>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/aboutus" onClick={handleNavClick}>
                ABOUT US
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/contactus" onClick={handleNavClick}>
                CONTACT US
              </NavLink>
            </li>
          </ul>

          {/* CONTACT INFO (DESKTOP ONLY) */}
          <div className="d-none d-lg-flex gap-3">
            <div className="contact-pill">
              <i className="fa fa-envelope"></i> anekant.prakashan@gmail.com
            </div>
            <div className="contact-pill">
              <i className="fa fa-phone"></i> +91 9552826112
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
